<template>
  <ItemPage
    :title="title"
    size="md"
    :actions="actions"
  >
    <template
      v-if="gradeView"
    >
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="10"
            item-key="id"
          >
            <template #item.name="{ item }">
              <router-link :to="{ name: 'reinos.EducationSystem.educationSystemID.EducationStage.educationStageID.Grade.gradeID', params: { gradeID: item.id } }">
                {{ item.name }}
              </router-link>
            </template>
            <template #item.status="{ item }">
              {{ item.status ? 'Ativo' : 'Inativo' }}
            </template>
            <template #item.created_at="{ item }">
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="openFormEditItemDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                class="mx-2"
                outlined
                small
                fab
                color="primary"
                @click="confirmDelete(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      seu usuário não tem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import FormAddNewItemDialog from '@/components/settings/FormAddNewItemDialog.vue'
import FormEditItemDialogWithShortName from '@/components/settings/FormEditItemDialogWithShortName.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'

export default {
  components: {
    Load,
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      title: 'Cursos',
      educationStage: null,
      gradeView: false,
      loading: false,
      loadingMsg: '',
      contents: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        },
        {
          text: 'Slug',
          align: 'start',
          value: 'slug'
        },
        {
          text: 'Ordem',
          align: 'start',
          value: 'order'
        },
        {
          text: 'Status',
          align: 'start',
          value: 'status'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'created_at'
        }
      ]
    }
  },

  computed: {
    id () {
      return this.$route.params.educationStageID
    },
    actions () {
      return [
        {
          label: 'Adicionar Curso',
          action: this.openFormAddNewitemDIalog,
          icon: 'mdi-plus',
          disabled: !this.gradeView
        }
      ]
    },

    educationStageID () {
      return this.$route.params.educationStageID
    }
  },
  async mounted () {
    await this.fetchAll()
  },
  methods: {

    async fetchAll () {
      // this.gradeView = utils.checkPermissions('intranet-users.view-any')
      this.gradeView = true
      try {
        this.educationStage = await this.$api.getEducationStages(this.id)
        this.title = this.educationStage.short_name + ' - ' + this.educationStage.education_system.short_name
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o segmento, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
      await this.listGrades()
    },
    async listGrades () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        this.contents = await this.$api.listGrades(this.educationStageID)
      } catch (e) {
        this.getErrors(e)
      }
      this.loading = false
    },
    openFormAddNewitemDIalog () {
      this.$dialog.custom(FormAddNewItemDialog).with({ title: 'Curso', action: this.newGrade }).show()
        .then((educationStage) => {
          if (!educationStage) {
            return false
          }
          this.listGrades()
        })
    },
    openFormEditItemDialog (grade) {
      this.$dialog.custom(FormEditItemDialogWithShortName).with({ title: 'Curso', item: grade, action: this.updateGrade }).show()
        .then((updatedGrade) => {
          if (!updatedGrade) {
            return false
          }
          this.listGrades()
        })
    },
    async newGrade (data) {
      await this.$api.newGrade(this.educationStageID, data)
    },
    async updateGrade (id, data) {
      await this.$api.updateGrade(id, data)
    },
    async confirmDelete (item) {
      this.$dialog.confirm(`Apagar ${item.name}?`)
        .text('Tem certeza que deseja apagar? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.deleteGrade(item.id)
        })
        .show()
    },
    async deleteGrade (id) {
      try {
        await this.$api.deleteGrade(id)
        this.$store.dispatch('setSnackBar', { text: 'Curso apagado com sucesso.' })
        this.listGrades()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível apagar o Curso, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
